// Components.js

/* base components */
import Catalog   from './modules/catalog/Catalog'
import Search    from './modules/catalog/Search'
import Result    from './modules/catalog/Result'
import FourOFour from './modules/404/FourOFour'
import Header    from './modules/header/Header'
import Footer    from './modules/footer/Footer'
import Callback  from './modules/callback/Callback'

/* additional components */
import Hello              from './modules/hello/Hello'
import PasswordReset      from './modules/password/PasswordReset'
import PubSub             from './modules/pubsub/PubSub'
import UrlShortener       from './modules/url-shortener/UrlShortener'
import Chat               from './modules/chat/Chat'
import Feedback           from './modules/feedback/Feedback'
import Joke               from './modules/joke/Joke'
import EmployeeOnboarding from './modules/employee-onboarding/EmployeeOnboarding'
import Systems            from './modules/systems/Systems'
import Template           from './modules/--template--/Template'
import TestMaintenance    from './modules/test-maintenance/TestMaintenance'
import Connect            from './modules/connect/Connect'

/* base exports */
export { Catalog }
export { Search }
export { Result }
export { FourOFour }
export { Header }
export { Footer }
export { Callback }

/* additional exports */
export { Hello }
export { PasswordReset }
export { PubSub }
export { UrlShortener }
export { Chat }
export { Feedback }
export { Joke }
export { EmployeeOnboarding }
export { Systems }
export { Template }
export { TestMaintenance }
export { Connect }


/* define lookup overrides functionality */
var _lookup = {
  '404': 'FourOFour',
  'Password-reset': 'PasswordReset',
  'Pubsub': 'PubSub',
  'url-shortener': 'UrlShortener',
  'access': 'EmployeeOnboarding',
  'test-maintenance': 'TestMaintenance',
}

export default function lookup(key) {
  if (key in _lookup) {
    return _lookup[key]
  }
  
  return key;
}